export var ListDaysStateType;
(function (ListDaysStateType) {
    ListDaysStateType["DEFAULT"] = "default";
    ListDaysStateType["DISABLED"] = "disabled";
    ListDaysStateType["HOVER"] = "hover";
    ListDaysStateType["CURRENT_DAY"] = "current_day";
    ListDaysStateType["CURRENT_DAY_DISABLED"] = "current_day_disabled";
    ListDaysStateType["SELECTED"] = "selected";
    ListDaysStateType["START_DATE_RANGE"] = "start_date_range";
    ListDaysStateType["END_DATE_RANGE"] = "end_date_range";
    ListDaysStateType["MIDLE_DATE_RANGE"] = "midle_date_range";
})(ListDaysStateType || (ListDaysStateType = {}));
//# sourceMappingURL=state.js.map